import { type ModuleWithProviders, NgModule } from '@angular/core';

import {
  ConversationStartersStoreModule,
  TellentAssistantCurrentThreadStoreModule,
  TellentAssistantEngagementsStoreModule,
  TellentAssistantSuggestionsStoreModule,
  TellentAssistantThreadsStoreModule,
} from '@core/tellent-assistant-logic';

import { buildTellentAssistantHostNonNgrxProviders } from './tellent-assistant-host.providers';

/**
 * Legacy NgModule bridge for apps that still bootstrap with `StoreModule.forRoot(...)`
 * + `EffectsModule.forRoot(...)` in their root `NgModule.imports`. Prefer
 * `provideTellentAssistantHost({...})` in new code.
 *
 * Delete once every host is on standalone `provideStore`/`provideEffects`.
 */
@NgModule({
  imports: [
    TellentAssistantThreadsStoreModule,
    TellentAssistantCurrentThreadStoreModule,
    ConversationStartersStoreModule,
    TellentAssistantSuggestionsStoreModule,
    TellentAssistantEngagementsStoreModule,
  ],
})
export class TellentAssistantHostModule {
  public static forRoot(): ModuleWithProviders<TellentAssistantHostModule> {
    return {
      ngModule: TellentAssistantHostModule,
      providers: [...buildTellentAssistantHostNonNgrxProviders()],
    };
  }
}
